// extracted by mini-css-extract-plugin
export default {"slideContainer":"_8932674819 _23fb5f3933 b527f73b88","slideImage":"_7de91e90aa"};